module.exports = __webpack_public_path__ + "static/cannon2-c060bef79ba017f95e14d3c85c3b09cb.png";